import {create} from 'zustand'
import {subscribeWithSelector} from "zustand/middleware";

export const useClassRegistrationFormStore = create(subscribeWithSelector((set) => ({
  isOnlyFormWomen: tanecniskola_class_registration.is_only_for_women,
  availableSex: [],
  firstPersonSex: 'female',
  secondPersonSex: 'male',
  setAvailableSex: (value) => set((state) => ({availableSex: value})),
  setFirstPersonSex: (sex) => set((state) => ({firstPersonSex: sex})),
  setSecondPersonSex: (sex) => set((state) => ({secondPersonSex: sex})),
})))